interface IData {
  type: string;
  value: unknown;
}

type TData = Record<string, IData>;

export const getPhone = (data: TData) => {
  const phone = Object.values(data).find((item) => item.type === 'phone');

  return phone ? (phone.value as string) : 'no phone';
};
